import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import ReactSelect from 'react-select/lib/Async';
import fetch from 'unfetch';

import { parseGeoCoderResult, getSuggestUrl, getGeoCodingUrl } from './utils';

import DropdownIndicator from '~/core/scripts/components/CustomReactSelect/DropdownIndicator';
import ClearIndicator from '~/core/scripts/components/CustomReactSelect/ClearIndicator';

class Geocoder extends PureComponent {
  static propTypes = {
    hereAppId: PropTypes.string,
    hereAppCode: PropTypes.string,
    center: PropTypes.arrayOf(PropTypes.number),
    country: PropTypes.string,
    radius: PropTypes.number,
    onSelect: PropTypes.func,
    notFoundMessage: PropTypes.string,
    placeholder: PropTypes.string,
  }

  static defaultProps = {
    hereAppId: 'z3eX9853o6uIeqWeqrGA',
    hereAppCode: 'nw1bJwSGczJRGF5I-p-wkA',
    center: [52.50697,13.2843072],
    country: 'DEU',
    radius: 25000,
    onSelect: () => {},
    notFoundMessage: 'Die Adresse konnte nicht gefunden werden.',
    placeholder: 'Geben Sie eine Stadt ein...',
  }

  loadOptions(inputValue) {
    const requestUrl = `https://api.fnki.de/api/autocomplete-gemeinden?&q=${encodeURIComponent(inputValue)}`;

    return new Promise(async (resolve, reject) => {
      const response = await fetch(requestUrl);
      const options = await response.json();
      resolve(parseGeoCoderResult(options));
    });
  }

  handleSelect = (option) => {
    if (!option) {
      return false;
    }

    this.props.onSelect(option);
  }

  render() {
    return (
      <div className="geocoder">
        <ReactSelect
          loadOptions={inputValue => this.loadOptions(inputValue)}
          getOptionLabel={option => option.label}
          classNamePrefix={"select"}
          cacheOptions
          isClearable
          openMenuOnClick={false}
          openMenuOnFocus={false}
          onBlurResetsInput={false}
          onChange={option => this.handleSelect(option)}
          placeholder={this.props.placeholder}
          noOptionsMessage={input => {
            if (!input.inputValue || input.inputValue.length < 2) {
              return null;
            }

            return this.props.notFoundMessage;
          }}
          components={{
            DropdownIndicator,
            ClearIndicator,
            IndicatorSeparator: () => null
          }}
        />
      </div>
    );
  }
}

export default Geocoder;
